// Overlay > IOverlay
import { ComponentType } from 'react'
import { IBlockData } from '../BlockData'
import { IBlockType } from '../BlockType'

export const defaultProps = Object.freeze({
	multiTypeSelect: false
})

export type OverlayState = {
	start: number
	end: number
	selected: string[]
}

export type OverlayContentProps<BlockTypesType> = {
	block: IBlockData<BlockTypesType>
	selectedBlockTypes: IBlockType<BlockTypesType>[]
	labelConversion: (ix: number) => string
	handleClose(event: React.MouseEvent<HTMLButtonElement>): void
	findCurrentBlockInstance(searchFor: IBlockData<BlockTypesType>): IBlockData<BlockTypesType> | undefined
}

export type OverlayProps<BlockTypesType> = {
	block: IBlockData<BlockTypesType>
	blockTypes: IBlockType<BlockTypesType>[]
	Content: ComponentType<OverlayContentProps<BlockTypesType>>
	labelConversion: (ix: number) => string
	handleClose(event: React.MouseEvent<HTMLButtonElement>): void
	findCurrentBlockInstance(searchFor: IBlockData<BlockTypesType>): IBlockData<BlockTypesType> | undefined
} & typeof defaultProps
